<template>
  <v-dialog v-model="isUploading" width="60%" height="40%" persistent>
    <v-card>
      <v-card-title>{{ $t('media.wait') }}</v-card-title>
      <v-card-text>
        <v-progress-linear
          mr-4
          ml-4
          :value="percentProgress"
          color="primary"
          height="10"
        ></v-progress-linear>
        <p>{{ percentProgress }} /100</p>
      </v-card-text>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  name: 'load-dialog',
  components: {},
  data() {
    return {};
  },
  props: {
    isUploading: {
      type: Boolean,
      default: false,
    },
    percentProgress: {
      type: Number,
      default: 0,
    },
  },
};
</script>
